import { useRef, useCallback, useState } from 'react';

type PositionMap = Map<string, DOMRect>;

export function useVersionSwapAnimation() {
  const containerRef = useRef<HTMLDivElement>(null);
  const positionsRef = useRef<PositionMap>(new Map());
  const [isAnimating, setIsAnimating] = useState(false);

  const capturePositions = useCallback(() => {
    if (!containerRef.current) return;
    const cells = containerRef.current.querySelectorAll('[data-version-id]');
    const positions = new Map<string, DOMRect>();
    cells.forEach(cell => {
      const id = cell.getAttribute('data-version-id');
      if (id) positions.set(id, cell.getBoundingClientRect());
    });
    positionsRef.current = positions;
  }, []);

  const animateSwap = useCallback(() => {
    if (!containerRef.current) return;
    const cells = containerRef.current.querySelectorAll('[data-version-id]');

    cells.forEach(cell => {
      const id = cell.getAttribute('data-version-id');
      const oldPos = positionsRef.current.get(id!);
      if (!oldPos) return;

      const newPos = cell.getBoundingClientRect();
      const deltaY = oldPos.top - newPos.top;

      if (Math.abs(deltaY) > 1) {
        const element = cell as HTMLElement;
        element.style.transform = `translateY(${deltaY}px)`;
        element.style.transition = 'none';

        cell.getBoundingClientRect();

        element.style.transition = 'transform 300ms ease-out';
        element.style.transform = '';
      }
    });

    setIsAnimating(true);
    setTimeout(() => setIsAnimating(false), 300);
  }, []);

  return { containerRef, capturePositions, animateSwap, isAnimating };
}
